<template>
  <el-dialog
    :visible.sync="showModal"
    :before-close="handleBeforeClose"
    title="Pay Campaign User"
    width="400px"
    @open="handleOpen"
    @closed="handleClosed">

    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      label-position="top"
      label-width="120px">

      <el-form-item
        label="Payment Method"
        prop="paymentMethod">
        <el-select
          v-model="form.paymentMethod"
          placeholder="Select"
          style="width: 100%;">
          <el-option
            v-for="item in paymentTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="isPayPalPaymentMethodSelected"
        label="PayPal Tran ID"
        prop="paypalTransactionId">
        <el-input
          v-model="form.paypalTransactionId"
          placeholder="Optional"
        />
      </el-form-item>

      <el-form-item
        label="Amount"
        prop="amount">
        <el-input
          v-model="form.amount"
          placeholder="Please input">
          <el-select
            slot="prepend"
            v-model="form.currency"
            placeholder="$$"
            style="width: 80px;">
            <el-option
              v-for="item in currencyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-input>
      </el-form-item>

      <el-form-item
        label="Payout Date"
        prop="payoutDate">
        <el-date-picker
          v-model="form.payoutDate"
          :default-value="new Date()"
          style="width: 100%;"
          type="date"
          placeholder="Pick a date"
          value-format="yyyy-MM-dd"/>
      </el-form-item>

      <el-form-item>
        <el-button
          :loading="isLoading"
          type="danger"
          @click="handlePayButtonClicked">Pay</el-button>
        <el-button
          :disabled="isLoading"
          @click="resetForm">Reset</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { updateCampaignPayment } from '../../../api/rewardsnap'
import { currencyList } from '../../../utils/const'
import { validateIsNumber } from '../../../utils/element-ui-form-validators'

export default {
  name: 'CampaignPaymentUpdateDetailModal',
  props: {
    campaignUser: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.getDefaultForm(),
      formRules: {
        paymentMethod: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'change' }],
        amount: [{ required: true, validator: validateIsNumber, trigger: 'blur' }],
        payoutDate: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'blur' }],
      },
      paymentTypes: [
        { value: 'bank_transfer', label: 'Bank Transfer' },
        { value: 'paypal', label: 'PayPal' },
        { value: 'cheuqe', label: 'Cheuqe' },
      ],
      currencyList,
      isLoading: false,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },
    isPayPalPaymentMethodSelected() {
      return this.form.paymentMethod === 'paypal'
    },
  },
  methods: {
    async updateCampaignDetailForUser() {
      this.isLoading = true
      const params = { ...this.form }
      if (!this.isPayPalPaymentMethodSelected) {
        params.paypalTransactionId = ''
      }

      try {
        const response = await updateCampaignPayment(this.campaignUser.campaign_id, this.campaignUser.user_id, params)
        const paidResult = response.data
        this.isLoading = false
        this.$emit('paid', paidResult)
        this.$emit('close')
        this.handleClosed()
      } catch (error) {
        this.isLoading = false
      }
    },
    handlePayButtonClicked() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.updateCampaignDetailForUser()
      })
    },
    handleOpen() {
      this.form.currency = this.campaignUser.currency
      this.form.amount = this.campaignUser.amount
    },
    handleBeforeClose(done) {
      if (this.isLoading) return
      done()
    },
    handleClosed() {
      this.cleanUp()
    },
    cleanUp() {
      this.isLoading = false
      this.resetForm()
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.form = this.getDefaultForm()
    },
    getDefaultForm() {
      const now = new Date()
      const payoutDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-15`

      return {
        paymentMethod: 'bank_transfer',
        currency: 'HKD',
        amount: '',
        paypalTransactionId: '',
        payoutDate: payoutDate,
      }
    },
  },
}
</script>
